import __vue_component__ from '../Button/Button.vue.js';
import EditorCloseIcon from '../Icon/EditorCloseIcon.js';
import Checked from '../Icon/EditorDoneIcon.js';

//
var script = {
  name: 'InlineEditButtons',
  components: {
    EditorDoneIcon: Checked,
    Button: __vue_component__,
    EditorCloseIcon
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },

    onCancel() {
      this.$emit('cancel');
    },

    onFocus(event) {
      this.$emit('focus', event);
    },

    onBlur(event) {
      this.$emit('blur', event);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/InlineEditButtons.vue_rollup-plugin-vue=script.js